/**
 * Glidejs slider pagination module.
 * Glidejs accepts functions as components ONLY!
 * On default Glide-, Components- and Events-object are passed to a custom glidejs-component
 * @see https://glidejs.com/docs/extending-components/
 * @param {object} Glide
 * @param {object} Components
 * @param {object} Events
 * @return {{mount(): void, setSliderMaxCount(): void, setCurrentPageIndex(): void}}
 * @constructor
 */

const SliderPagination = function SliderPagination(Glide, Components, Events) {
  const config = {
    elements: {
      prev: '[data-glide-dir="<"]',
      next: '[data-glide-dir=">"]',
      current: '[data-hero-slider-current-page]',
      total: '[data-hero-slider-total-page-count]',
    },
    modifier: {
      disabled: 'hero-slider__pagination-button--disabled',
      oneSlide: 'hero-slider__controls--one-slide',
    },
  };

  /**
   * Custom glidejs component.
   * Returns the current page of pagination and the total number of slides.
   * @see https://glidejs.com/docs/extending-components/
   * @type {{mount(): void, updateCurrentView(): void, updateTotalView(): void}}
   */
  const GlideSlideCount = {
    /**
     * global hook for glidejs slider mount.
     * fired when slider is mounted and get the total slide number.
     */
    mount() {
      Events.emit('slideCount.mount');
      this.totalCount = Components.Sizes.length;
      this.controlsContainer = null;
      [this.controlsContainer] = Components.Controls.items;
      this.prevButton = Components.Controls.items[0].querySelector(config.elements.prev);
      this.nextButton = Components.Controls.items[0].querySelector(config.elements.next);
      this.totalView = Components.Controls.items[0].querySelector(config.elements.total);
      this.currentView = Components.Controls.items[0].querySelector(config.elements.current);
      if (this.totalCount > 1) {
        this.updateCurrentView();
        this.updateTotalView();
      } else {
        this.controlsContainer.classList.add(config.modifier.oneSlide);
        Glide.disable();
      }
    },

    /**
     * Custom method for glidejs component
     * update the value shown for current page
     * and sets arrows as disabled when no further navigation is possible
     */
    updateCurrentView() {
      const currentPage = Glide.index + 1;
      this.currentView.innerText = currentPage;

      this.prevButton.classList.remove(config.modifier.disabled);
      this.nextButton.classList.remove(config.modifier.disabled);

      switch (currentPage) {
        case 1:
          this.prevButton.classList.add(config.modifier.disabled);
          break;
        case (this.totalCount):
          this.nextButton.classList.add(config.modifier.disabled);
          break;
        default:
          break;
      }
    },

    /**
     * Custom method for glidejs component
     * updates the total amount of pages in view
     */
    updateTotalView() {
      this.totalView.innerText = this.totalCount;
    },
  };

  /**
   * fired on glide-event "run.after"
   * "run.after" is fired when slider is moved to next/previous slide
   * @see https://glidejs.com/docs/events/
   */
  Events.on('run.after', () => {
    if (Components.Sizes.length > 1) {
      GlideSlideCount.updateCurrentView();
    }
  });

  return GlideSlideCount;
};

export default SliderPagination;
